/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMaxIcon16Light = forwardRef('ArrowDim4DiagMaxIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.5 6.5A.5.5 0 0 0 14 6V3a1 1 0 0 0-1-1h-3a.5.5 0 0 0 0 1h2.293L9.146 6.146a.5.5 0 1 0 .708.708L13 3.707V6a.5.5 0 0 0 .5.5Z" }),
        React.createElement("path", { d: "m3.707 13 3.147-3.146a.5.5 0 1 0-.708-.708L3 12.293V10a.5.5 0 0 0-1 0v3a1 1 0 0 0 1 1h3a.5.5 0 0 0 0-1H3.707Z" }),
        React.createElement("path", { d: "M9.146 9.854 12.293 13H10a.5.5 0 0 0 0 1h3a1 1 0 0 0 1-1v-3a.5.5 0 0 0-1 0v2.293L9.854 9.146a.5.5 0 1 0-.708.708Z" }),
        React.createElement("path", { d: "M3 3.707V6a.5.5 0 0 1-1 0V3a1 1 0 0 1 1-1h3a.5.5 0 0 1 0 1H3.707l3.147 3.146a.5.5 0 1 1-.708.708L3 3.707Z" })));
});
